import { render, staticRenderFns } from "./AdditionList.vue?vue&type=template&id=eedb2c6a&"
import script from "./AdditionList.vue?vue&type=script&lang=ts&"
export * from "./AdditionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports